import React, { useEffect } from "react";
import { List, ListItem, ListItemText, ListItemIcon, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Creators } from "../../../actions/dashboardActions";
import { getModuleIcon } from "../../../common/moduleData";
import CircularProgressCentered from "../../CircularProgressCentered";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

const ActivityListItem = ({ label, count, route, moduleNm, classes }) => {
	const Icon = getModuleIcon(moduleNm);

	return (
		<ListItem component={Link} to={`${route}`}>
			<ListItemIcon className={classes.ListIcon}><Icon /></ListItemIcon>
			<ListItemText 
				primaryTypographyProps={{ color: "primary" }}
				primary={`${label} (${count})`} />
		</ListItem>
	);
};

const activities = [
	{ label: "Pending Events", key: "pendingEventCalendars", route: "/grid/eventCalendar?view=All Pending Events", moduleNm: "eventCalendar" },
	{ label: "Pending Listings", key: "pendingListings", route: "/grid/listing?view=All Pending Listings", moduleNm: "listing" },
	{ label: "Pending Offers", key: "pendingOffers", route: "/grid/offer?view=All Pending Offers", moduleNm: "offer" }
];

const PendingActivity = ({ setDashboardData, fetchPending, classes, data = {}, setLastFilter }) => {
	useEffect(() => {
		fetchPending();
		return () => {
			setDashboardData({ pendingListings: undefined, pendingOffers: undefined, pendingEventCalendars: undefined });
		};
	}, []);

	return (
		<React.Fragment>
			{data.pendingListings === undefined ? (
				<CircularProgressCentered size={75} color="secondary" />
			) : (
				<React.Fragment>
					<Typography variant="h2">
						Pending Reviews
					</Typography>
					<List>
						{activities.map(activity => {
							const { key, label, route, moduleNm } = activity;
							return <ActivityListItem label={label} count={data[key] || 0} route={route} key={key} moduleNm={moduleNm} classes={classes}/>;
						})}
					</List>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

const mapStateToProps = state => ({
	data: state.dashboard.data
});

const mapDispatchToProps = {
	setDashboardData: Creators.setDashboardData,
	fetchPending: Creators.fetchPending,
	setLastFilter: Creators.setLastFilter,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(styles)(PendingActivity));
